import React from 'react'
import MenuPlato from '../design.system/MenuPlato'

const MenuCollapsable = ({ children }) => {
  return (
    <MenuPlato>{children}</MenuPlato>
  )
}

export default MenuCollapsable
